import { ComgateOnboardingStatus } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding;

const COMGATE_STATUSES_REQUIRING_ACTION: Array<ComgateOnboardingStatus> = [
  ComgateOnboardingStatus.ERRORS_IN_DOCUMENTS,
  ComgateOnboardingStatus.ERROR_ACTION_PENDING,
  ComgateOnboardingStatus.WAITING_FOR_DOCUMENTS,
  ComgateOnboardingStatus.REJECTED,
];

export const isComgateStatusRequiringAction = (
  status: ComgateOnboardingStatus | null | undefined,
): boolean =>
  status != null && COMGATE_STATUSES_REQUIRING_ACTION.includes(status);

export const formatTimeSinceSubmit = (
  submittedAt: string | null | undefined,
  t: TFunction,
): string => {
  if (!submittedAt) {
    return "";
  }

  const diffMs = Date.now() - new Date(submittedAt).getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours < 24) {
    return t(RESOURCES.Table.Hours, { count: diffHours });
  }

  const diffDays = Math.floor(diffHours / 24);

  return t(RESOURCES.Table.Days, { count: diffDays });
};
